import {FILE_REQUIREMENT_COLLECTION} from '../../domain/config';
import {getProjectRequirementFilesList} from '../../reducers/state';
import {makeReqFileList} from '../config/configReqFileList';
import {PROJECT_FILES_LIST_PREFIX} from '../state';


export const {
  reduxList,
  componentOptions,
  isVisible,
} = makeReqFileList({
  prefix: PROJECT_FILES_LIST_PREFIX,
  getState: getProjectRequirementFilesList,
  parentPath: 'project-file-requirements',
  resourcePath: `file-fulfillments`,
  childPath: 'files',
  syncNotifierParentPath: FILE_REQUIREMENT_COLLECTION,
});



// WEBPACK FOOTER //
// ./src/js/requirements/redux/fulfillments/projectReqFilesList.js